/* eslint-disable */
const spainTerms = "I have read and accept the {{terms_and_conditions}} of Time Out"
export default {
  'en-GB': {
    common: {
      NAME_HOLDER: "First name *",
      LAST_NAME_HOLDER: "Last name *",
      EMAIL_HOLDER: "Your email address *",
      PASS_HOLDER: "Enter your password *",
      REPEAT_PASS_HOLDER: "Repeat your password *",
      BUTTON_EMAIL_SIGN_UP: "Sign Up with Email",

      TERMS_AND_CONDITIONS: "Terms and Conditions",
      PRIVACY_POLICY: "Privacy Policy",

      NEWSLETTER_CONSENT: "I consent to receiving emails from Time Out about the latest news, events, offers and partner promotions",
      TERM_OF_USE: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "I have read and accept the {{terms_and_conditions}} and {{privacy_policy}} of Time Out, including opt-in to marketing communications",
      HEADER_TITLE: "Create a <span>Time Out Account</span>",
      JOIN_FB: "Join with Facebook",
      JOIN_TW: "Join with Twitter",
      JOIN_GG: "Join with Google",
      JOIN_EM: "Join with Email",
      ALREADY_HAVE: "Already have a Time Out account?",
      CREATE_ACCOUNT_LOG_IN: "Log In",

      SIGN_IN_TITLE: "Sign In",
      SIGN_IN_FB: "Sign In with Facebook",
      SIGN_IN_TW: "Sign In with Twitter",
      SIGN_IN_GG: "Sign In with Google",
      SIGN_IN_EM: "Sign In with Email",
      YOUR_EMAIL: "Your email address",
      YOUR_PASSWORD: "Your password",
      REMEMBER: "Remember me",
      FORGOT: "Forgot?",
      FORGOT_PASSWORD: "Forgot Password?",
      HAVE_ACCOUNT_YET: "Don't yet have a Time Out account?",
      JOIN_HERE: "Join here",
      ALMOST_THERE: "Almost there",

      FORGOT_HEADER: "Forgot your password?",
      FORGOT_SUBTITLE: "No problem. Just enter your email address below - we'll send you a link to reset it",
      SEND_LINK: "Reset my password",

      RECEIVE_EMAIL: "Thank you, if you have previously registered with us using this email address you'll receive an email shortly",
      MANAGE_ACCOUNT: "Manage your account",
      EDIT_DETAILS_HERE: "You can edit your account details here",
      FIRST_NAME: "First Name",
      LAST_NAME: "Last Name",
      SCREEN_NAME: "Screen Name",
      EMAIL: "Email",
      ACCOUNT_DETAILS: "Account details",
      PASSWORD: "Password",
      SAVE_CHANGES: "SAVE CHANGES",
      UPLOAD_PIC: "Upload a new profile picture",
      CHOOSE_PHOTO: "Choose a photo from your device. The maximum size is 2MB.",
      CLOSE_ACCOUNT: "Close my account",
      PASSWORD_BELOW: "You can change your password below",
      CURRENT_PASSWORD: "Current password",
      NEW_PASSWORD: "New password *",
      REPEAT_PASSWORD: "Repeat new password *",
      CONFIRM_PASSWORD: "Confirm password",

      OOPS: "Oops,",
      ERROR_404_OCCURED: "an error occurred…",
      ERROR_404_INFO: "We have either moved the page or it no longer exists",
      ERROR_500_TITLE: "The server returned a ",
      SMTH_BROKEN: " Something is broken",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Please let us know",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Please enter a valid email address",
      FIRST_NAME_ERROR: "Please enter your first name",
      LAST_NAME_ERROR: "Please enter your last name",
      TERM_OF_USE_ERROR: "You must agree to our terms of use",
      SIGN_IN_VALIDATION_ERROR: "Incorrect email or password - please try again",
      ACCOUNT_PASSWORDS_VALIDATION: "Passwords do not match",
      WAS_IT: "Was it something we did?",
      DELETE_ACCOUNT_TEXT: "We're sorry you're thinking of deleting your account. If there's something that's made you want to leave, ",
      DELETE_ACCOUNT: "Delete Account",
      CANCEL: "Cancel",

      UPDATE_PASSWORD: "Update your password",
      PASSWORD_UPDATE_SUCCESS: "Your password has been updated",
      ERROR_PASSWORD_LENGTH: "Password must contain between 6 and 64 characters",

      ERROR_MISSING_SITE_PARAMETER: "Missing required application parameter: site",
      ERROR_ALREADY_REGISTERED: "You are already registered using email signup. Please login using {{email}}",

      BACK: 'Back',
      HERE: 'here',
      GP_FORGOT_HEADER: 'Forgot your password?',
      GP_PLANS_THANK_YOU_HEADER: 'Thank you for your order!',
      GP_PLANS_THANK_YOU_DESCRIPTION: 'A confirmation email is on its way to {{email}}',
      GP_PLANS_THANK_YOU_CONTINUE: 'Continue to site',
      GP_FORGOT_SUBTITLE: `No problem. Just enter your email address below - we'll send you a link to reset it`,
      GP_SEND_LINK: 'Reset my password',
      GP_YOUR_EMAIL: 'Your email address',
      GP_RECEIVE_EMAIL: `Thank you, if you have previously registered with us using this email address you'll receive an email shortly`,
      GP_LOGIN_TITLE: 'Sign In',
      GP_EXP_TITLE: "Choose your advertising experience",
      GP_PLAN_1_TITLE: "Purchase Time Out Ad-Free",
      GP_PLAN_1_BULLET_1: "Time Out Ad Free enables you to read the Time Out website without any ads.",
      GP_PLAN_1_BULLET_2: "We will not share any of your data with advertisers.",
      GP_PLAN_1_CTA: "Pay to reject ads for €2",
      GP_PLAN_2_TITLE: "Read Time Out with personalised ads",
      GP_PLAN_2_BULLET_1: "Click ‘Go back to Accept all’ if you do not want to subscribe to Time Out Ad-Free.",
      GP_PLAN_2_CTA: "Go back to 'Accept All'",
      GP_HAVE_ACCOUNT_YET: "Already have a Time Out Ad Free account?",
      GP_QA_TITLE: "Any questions?",
      GP_QA_QUESTION_1: "What's actually included with Time Out Ad-Free?",
      GP_QA_ANSWER_1_PART1: "For a one-off payment of 2€, you will experience Time Out completely free of ads. This is a one time only payment and limited to 30 days from the date of purchase.<br/><br/> You won't see traditional display ads, pop-ups, or pre-roll video ads that usually appear on our website. It’s your ticket to an uninterrupted journey through the best of the city and beyond. When we say \"ad-free,\" we mean we won't use cookies or similar technologies to follow your browsing activity for targeted advertising purposes or to share with third-party advertisers. We do, however, collect anonymous and aggregated data to ensure our website functions perfectly, to understand how our content is performing, and to continually improve your experience – all strictly in line with our ",
      GP_QA_ANSWER_1_PART2: ".<br/><br/><strong>Important Note:</strong> While we banish external ads, this doesn't affect Time Out's own curated editorial content, which may include clearly marked sponsored features, native articles, or affiliate links to events and products we genuinely recommend. These are part of our editorial offering, not third-party advertising.",
      GP_QA_QUESTION_2: "Will Time Out Ad-Free work across all my devices?",
      GP_QA_ANSWER_2_PART1: "Absolutely! Your Time Out Ad-Free benefits are cleverly linked to your Time Out account. So, whether you're planning your next adventure on your desktop, grabbing inspiration on your tablet, or checking out what's on your mobile, simply log in with your usual Time Out credentials on any compatible web browser, and the ad-free magic will follow you.\nAlready got an account? Log in ",
      GP_QA_ANSWER_2_PART2: ".",
      GP_QA_QUESTION_3: "How do I access Time Out Ad-Free if I've logged in on one device but move to another?",
      GP_QA_ANSWER_3_PART1: "No fuss, no faff! Just make sure you're logged into your Time Out account on your new device. If you're still seeing ads, a quick refresh or a visit to the 'Manage Cookies' link in our website footer should do the trick. This will confirm your login status and apply your ad-free and tracking-free benefits automatically.\nAlready got an account? Log in ",
      GP_QA_ANSWER_3_PART2: ".",
      GP_QA_QUESTION_4: "How do I contact customer services?",
      GP_QA_ANSWER_4_PART1: "If you experience any issues, our dedicated support team is here to help. Drop us a line at support@timeout.com. We aim to respond to all queries promptly.  ",
      GP_QA_ANSWER_4_PART2: ".",
      GP_QA_QUESTION_5: "What is your refund policy?",
      GP_QA_ANSWER_5_PART1: "Our full refund policy, including any pro-rata refunds for certain circumstances (e.g., if you cancel within a cooling-off period), is detailed in our ",
      GP_QA_ANSWER_5_PART2: ".",
      GP_CONFIRM_PAY: "Confirm and pay",
      GP_EDIT: "Edit",
      GP_TOTAL: "Total",
      GP_ORDER_TOTAL: "Order Total",
      GP_MONTH: "Month",
      GP_CHK_PLAN_1_TITLE: "Time Out Ad-Free",
      GP_YOUR_DETAILS: "Your details",
      GP_PAYMENT_METHOD: "Payment method",
      GP_NAME_CARD: "Name on card",
      GP_CARD_NUMBER: "Card number",
      GP_EXPIRY_DATE: "Expiry date",
      GP_CVV: "CVV",
      GP_POST_CODE: "Postcode",
      GP_AD_FREE_TERMS_AND_CONDITIONS: "Time Out Ad Free T&C",
      GP_TERMS_AND_CONDITIONS: "Time Out terms of use",
      GP_PRIVACY_POLICY: "Privacy notice",
      GP_ORDER_TERMS: "By completing this order I agree to the {{terms_and_conditions}}, {{privacy_policy}} and {{ad_free_terms_and_conditions}}",
      GP_ORDER_DISCLAIMER: "<strong>\"Ad-Free\"</strong>: The Ad-Free Service is designed to remove display ads, pop-up ads, and pre-roll video ads that usually show up within the editorial content areas of our Website during your Access Period.",
      GP_PAY_VALUE: "Pay {{value}}",
      BRAINTREE_cardholderName_ERROR: "card holder name error",
      BRAINTREE_number_ERROR: "card number error",
      BRAINTREE_expirationDate_ERROR: "card expiration date error",
      BRAINTREE_cvv_ERROR: "card cvv date error",
      BRAINTREE_postalCode_ERROR: "card postal code error",
      BRAINTREE_generic_ERROR: "generic error",
      PAYMENT_AUTHORIZATION_FAILED: "Oops! Payment unsuccessful. Please check your details and try again.",
      GP_THANK_YOU_LOGIN_FAIL_MESSAGE: "Your login details are correct, but Time Out no longer offers an ad-free subscription."
    },
    'es-barcelona': { TERM_OF_USE: spainTerms, },
    'es-madrid': { TERM_OF_USE: spainTerms, },
    'es-girona': { TERM_OF_USE: spainTerms, },
  }
}



// WEBPACK FOOTER //
// ./translations/en-GB.js